
















helpers = require('../../../helpers.coffee')

view_model = {
  components:
    list: require('./list')
    confirmDestroy: require('../confirm_destroy')

  props: ['users_options']

  data: ->
    task: new Task

  methods:
    showConfirmDestroyModal: (data) ->
      jQuery('#confirm-destroy-ozzy-task').modal 'show'
      @task = data.task

    cancelRemoving: ->
      jQuery('#confirm-destroy-ozzy-task').modal 'hide'

    taskDestroyed: (data) ->
      EventsBus.$emit 'Task::Destroyed', data.task
      jQuery('#confirm-destroy-ozzy-task').modal 'hide'
      alertify.success 'Ozzy task excluída com sucesso!'

  computed:
    ozzy_tasks_filters: ->
      filters = {}
      filters.only_ozzy = true
      filters.undone = true
      filters.assigned_to_id_eq = Session.current_user.id
      filters

  created: ->
    @current_user = Session.current_user
    @tasks_resources = new TasksResource

}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/ozzy_tasks/ozzy_tasks_wrapper.vue